import React, { useState } from "react";
import RenderAccordions from "components/product/details/accordions";
import ReviewsSnippet from "components/reviews-snippet";
import { useGlobalContext } from "context/global";
import CollapsibleInfo from "components/collapsible-info";
import useCartSummary from "hooks/useCartSummary";
import ProductSlider from "components/product-slider";
import RichText from "components/rich-text";
import { formatTitle } from "helpers/format-title";
import BundleVariantOption from "./option";
import BundleWithVariantsGallery from "./gallery";
import SummaryBox from "components/summary-box";

const BundleWithVariants = ({ data }) => {
	const { infoBanner, benefits, title, bundles = [], productSlider = {}, ctaSubtitle, showProductSlider, hideCTALabel } = data;
	const { translation, cartSettings } = useGlobalContext();
	const defaultBundle = bundles.find(b => b.isDefault) || bundles[0];
	const [selectedBundle, setSelectedBundle] = useState(defaultBundle);
	const bundleWeight = selectedBundle.product.variant.weight;

	const currentBox = cartSettings.boxes.find(box => box.size.value === bundleWeight);
	const cartSummary = useCartSummary({
		currentBox, products: [{ ...selectedBundle.product, quantity: 1 }],
		totalWeight: bundleWeight,
		calcFirstOrderDiscount: true
	});

	return (
		<div className="hd-screen-max-width">
			<div className="md:w-80 m-auto flex flex-col lg:flex-row justify-between gap-x-10 gap-y-5">
				<div className="lg:w-[47%] lg:sticky lg:top-20 h-full">
					<BundleWithVariantsGallery images={selectedBundle.product?.images} />
				</div>

				<div className="px-3 flex flex-col md:mt-2 lg:w-[47%] mx-auto">
					<div className="px-3 lg:px-0">
						<h2>{formatTitle(title)}</h2>
						<ReviewsSnippet leftAlign />
						<div className="mb-3">
							<RichText value={data.description} />
						</div>
					</div>
					<div className="flex flex-col gap-y-3 mt-4 mb-6">
						{bundles.map(bundle => (
							<BundleVariantOption
								key={bundle._key}
								isActive={selectedBundle._key === bundle._key}
								setSelectedBundle={setSelectedBundle} bundle={bundle} />
						))}
					</div>
					{infoBanner && <CollapsibleInfo className="my-6" {...infoBanner} triggerClass="text-base" />}
					<SummaryBox
						title={title}
						bundle={selectedBundle}
						cartSummary={cartSummary}
						ctaSubtitle={ctaSubtitle}
						hideCTALabel={hideCTALabel}
					/>
					<div className="flex flex-col items-center justify-center pb-2">
						<p className="text-gray-500 text-sm text-center">
							{ctaSubtitle || `${translation.other?.checkoutMessage} | ${translation.other?.freeShipping}`}
						</p>
					</div>
					<hr className="border-gray-300 my-5 border-solid border-[0.5px]" />
					{benefits?.length > 0 &&
						<div>
							<p className="font-semibold mb-4">{translation.shopping_flow?.your_benefits}</p>
							<ul className="space-y-3">
								{benefits.map((benefit, index) => (
									<li key={index} className="flex space-x-5">
										<span className="size-2 bg-black rounded-full mt-4"></span>
										<div className="w-4/5">
											<p className="font-boldParagraph">{benefit.title}</p>
											<p className="text-secondary">{benefit.description}</p>
										</div>
									</li>
								))}
							</ul>
						</div>
					}
					<div className="pt-2.5">
						<RenderAccordions accordions={selectedBundle.accordions} />
					</div>
				</div>
			</div>
			{showProductSlider &&
				<div className="my-5 md:my-10">
					<ProductSlider
						navClass="!top-2/3 hover:!top-[67%]"
						data={{ ...productSlider, products: selectedBundle.product.details.products }} />
				</div>}
		</div>
	);
};

export default BundleWithVariants;